import React from 'react'

import { Tooltip } from '@material-ui/core'
import {
  TableFooter,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  Row,
} from 'components'
import { ViewFileIcon, DownloadIcon, StatusIcon } from 'components/Icons'
import { useFile } from 'hooks'
import { IHandleChangePage, IHandleChangeRowsPerPage } from 'hooks/useGet'
import { IConsultaDocumentosItens, Iitems } from 'services/GST/DocumentosItensSeguranca'

interface IDocumentTableProps {
  tableData: IConsultaDocumentosItens<Iitems[]>
  page: number,
  rowsPerPage: number,
  handleChangePage: IHandleChangePage
  handleChangeRowsPerPage: IHandleChangeRowsPerPage
  datesStatusOk: boolean
}

const DocumentsTable: React.FC<IDocumentTableProps> = ({
  tableData,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
  datesStatusOk
}) => {
  const { viewFile, downloadFile } = useFile()
  
  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled minwidth="20px" align="center">
                Empresa
              </TableCellStyled>
              <TableCellStyled minwidth="20px">Centro</TableCellStyled>
              <TableCellStyled minwidth="30px">Contrato</TableCellStyled>
              <TableCellStyled minwidth="30px">Fornecedor</TableCellStyled>
              <TableCellStyled minwidth="20px">Item Segurança</TableCellStyled>
              <TableCellStyled minwidth="20px" align="center">
                Data Anexo
              </TableCellStyled>
              <TableCellStyled minwidth="20px" align="center">
                Retorno Análise
              </TableCellStyled>
              <TableCellStyled minwidth="20px">Status</TableCellStyled>
              <TableCellStyled minwidth="40px" align="center">
                Ações
              </TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData?.items?.length > 0 &&
              tableData?.items?.map((row, index) => (
                <TableRowStyled key={index}>
                  <TableCellStyled align="center">
                    {row?.nmEmpresa || '---'}
                  </TableCellStyled>
                  <TableCellStyled>{row?.nmCentro || '---'}</TableCellStyled>
                  <TableCellStyled>{row?.cdContrato || '---'}</TableCellStyled>
                  <TableCellStyled>{row?.nmFornecedor || '---'}</TableCellStyled>
                  <TableCellStyled>{row?.nmItemSeguranca || '---'}</TableCellStyled>
                  <TableCellStyled align="center">
                    {row?.dtAnexo || "---"}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row?.dtRetorno || "---"}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    <Tooltip
                      arrow
                      title={row?.statusDescricao || ''}
                      placement="left"
                    >
                      <StatusIcon
                        value={row?.documentoStatus}
                        marginLeft="auto"
                        marginRight="auto"
                      />
                    </Tooltip>
                  </TableCellStyled>
                  <TableCellStyled>
                    <Row alignItems="center" justifyContent="center">
                      <ViewFileIcon 
                        cursor="pointer" 
                        onClick={() => 
                          viewFile({ gedExternalID: row?.gedExternalId })
                        } 
                        disabled={!row?.gedExternalId} 
                      />
                      <DownloadIcon 
                        cursor="pointer" 
                        onClick={() => 
                          downloadFile({ gedExternalID: row?.gedExternalId })
                        } 
                        disabled={!row?.gedExternalId} 
                      />
                    </Row>
                  </TableCellStyled>
                </TableRowStyled>
              ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={tableData?.items}
        totalItems={tableData?.pageCount}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        disabled={!datesStatusOk}
      />
    </>
  )
}

export default DocumentsTable
